import { render, staticRenderFns } from "./ThePart3Main.vue?vue&type=template&id=26071926&scoped=true"
import script from "./ThePart3Main.vue?vue&type=script&lang=js"
export * from "./ThePart3Main.vue?vue&type=script&lang=js"
import style0 from "./ThePart3Main.vue?vue&type=style&index=0&id=26071926&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26071926",
  null
  
)

export default component.exports